import ImageWidget from './ImageWidget';

export default ImageWidget;
